// src/components/layout/MainLayout.js
import React, { useState } from 'react';
import { Container } from 'react-bootstrap'; // Removed Row, Col as they aren't directly used here
import Header from './Header';
import Sidebar from './Sidebar';
import { useTranslation } from 'react-i18next';
import '../../styles/MainLayout.css'; // Import custom CSS for transitions

const MainLayout = ({ children }) => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();
    // State to control sidebar visibility
    const [isSidebarVisible, setIsSidebarVisible] = useState(true); // Default to visible

    // Function to toggle the sidebar state
    const toggleSidebar = () => {
        setIsSidebarVisible(!isSidebarVisible);
    };

    return (
        // Add a class to the main container based on sidebar visibility
        // This helps adjust content margin if needed (though transform is preferred)
        <div className={`main-layout-container d-flex vh-100 ${isSidebarVisible ? 'sidebar-visible' : 'sidebar-hidden'}`}>
            {/* Pass the visibility state and toggle function to Sidebar if needed */}
            {/* Or apply class directly as done below */}
            <Sidebar isVisible={isSidebarVisible} toggleSidebar={toggleSidebar}/>

            <div className="flex-grow-1 d-flex flex-column main-content-area">
                {/* Pass the toggle function to the Header */}
                <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible}/>

                {/* Main content area */}
                <main className="flex-grow-1 p-3 overflow-auto">
                    <Container fluid>
                        {children}
                    </Container>
                </main>
                {/* Optional Footer */}
                <footer className="footer-wrapper mt-auto py-3 bg-light"> {/* Use bg-light or another subtle background */}
                    <Container fluid className="text-center footer-powered-by">
                        © {currentYear} LMS. {t('poweredBy')} <a href="https://peocty.com/" target="_blank" rel="noopener noreferrer" className="fw-semibold">PEOCIT Technologies</a>. {/* Add link */}
                    </Container>
                </footer>
            </div>
        </div>
    );
};

export default MainLayout;